"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.6.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariant = instanceOfVariant;
exports.VariantFromJSON = VariantFromJSON;
exports.VariantFromJSONTyped = VariantFromJSONTyped;
exports.VariantToJSON = VariantToJSON;
exports.VariantToJSONTyped = VariantToJSONTyped;
const featureProducedByVariant_1 = require("./featureProducedByVariant");
const variantLegalities_1 = require("./variantLegalities");
const bracketTagEnum_1 = require("./bracketTagEnum");
const variantPrices_1 = require("./variantPrices");
const variantStatusEnum_1 = require("./variantStatusEnum");
const combo_1 = require("./combo");
const cardInVariant_1 = require("./cardInVariant");
const identityEnum_1 = require("./identityEnum");
const templateInVariant_1 = require("./templateInVariant");
/**
 * Check if a given object implements the Variant interface.
 */
function instanceOfVariant(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('uses' in value) || value['uses'] === undefined)
        return false;
    if (!('requires' in value) || value['requires'] === undefined)
        return false;
    if (!('produces' in value) || value['produces'] === undefined)
        return false;
    if (!('of' in value) || value['of'] === undefined)
        return false;
    if (!('includes' in value) || value['includes'] === undefined)
        return false;
    if (!('identity' in value) || value['identity'] === undefined)
        return false;
    if (!('manaNeeded' in value) || value['manaNeeded'] === undefined)
        return false;
    if (!('manaValueNeeded' in value) || value['manaValueNeeded'] === undefined)
        return false;
    if (!('easyPrerequisites' in value) || value['easyPrerequisites'] === undefined)
        return false;
    if (!('notablePrerequisites' in value) || value['notablePrerequisites'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('notes' in value) || value['notes'] === undefined)
        return false;
    if (!('popularity' in value) || value['popularity'] === undefined)
        return false;
    if (!('spoiler' in value) || value['spoiler'] === undefined)
        return false;
    if (!('bracketTag' in value) || value['bracketTag'] === undefined)
        return false;
    if (!('legalities' in value) || value['legalities'] === undefined)
        return false;
    if (!('prices' in value) || value['prices'] === undefined)
        return false;
    if (!('variantCount' in value) || value['variantCount'] === undefined)
        return false;
    return true;
}
function VariantFromJSON(json) {
    return VariantFromJSONTyped(json, false);
}
function VariantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': (0, variantStatusEnum_1.VariantStatusEnumFromJSON)(json['status']),
        'uses': (json['uses'].map(cardInVariant_1.CardInVariantFromJSON)),
        'requires': (json['requires'].map(templateInVariant_1.TemplateInVariantFromJSON)),
        'produces': (json['produces'].map(featureProducedByVariant_1.FeatureProducedByVariantFromJSON)),
        'of': (json['of'].map(combo_1.ComboFromJSON)),
        'includes': (json['includes'].map(combo_1.ComboFromJSON)),
        'identity': (0, identityEnum_1.IdentityEnumFromJSON)(json['identity']),
        'manaNeeded': json['manaNeeded'],
        'manaValueNeeded': json['manaValueNeeded'],
        'easyPrerequisites': json['easyPrerequisites'],
        'notablePrerequisites': json['notablePrerequisites'],
        'description': json['description'],
        'notes': json['notes'],
        'popularity': json['popularity'],
        'spoiler': json['spoiler'],
        'bracketTag': (0, bracketTagEnum_1.BracketTagEnumFromJSON)(json['bracketTag']),
        'legalities': (0, variantLegalities_1.VariantLegalitiesFromJSON)(json['legalities']),
        'prices': (0, variantPrices_1.VariantPricesFromJSON)(json['prices']),
        'variantCount': json['variantCount'],
    };
}
function VariantToJSON(json) {
    return VariantToJSONTyped(json, false);
}
function VariantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': (0, variantStatusEnum_1.VariantStatusEnumToJSON)(value['status']),
        'identity': (0, identityEnum_1.IdentityEnumToJSON)(value['identity']),
        'spoiler': value['spoiler'],
        'bracketTag': (0, bracketTagEnum_1.BracketTagEnumToJSON)(value['bracketTag']),
    };
}
//# sourceMappingURL=variant.js.map